import { Notification } from 'element-ui';
import {noReadCountMy} from "@/api/home";
const message = {
    state: {
        messageList: [],
        messageCount: 0,
        messageUnreadCount: 0,
    },
    mutations: {
        setMessageList(state, list){
            state.messageList = list;
        },
        setMessageCount(state, count){
            state.messageCount = count;
        },
        setMessageUnreadCount(state, count){
            state.messageUnreadCount = count;
        }
    },
    actions: {
        setMessageList({commit}, list){
            commit('setMessageList', list);
        },
        setMessageCount({commit}, count){
            commit('setMessageCount', count);
        },
        setMessageUnreadCount({commit}, count){
            noReadCountMy({}).then(res=>{
                if(res && res.code == 200){
                    commit('setMessageCount', res.data.count);
                }
            })
        },
        setMessageToast({}, message) {
            Notification({
                title: '',
                dangerouslyUseHTMLString: true,
                message: `<div class='notice-tip' id='message-notice' data-content='${message}'>${message.content}</div>`,
                onClick: (message) => {

                }
            })
        },
        handleMessage({commit, dispatch}, data) {
            if(data.msgType==7){
                dispatch('setMessageCount', data.content);
            }else{
                commit('setMessageList', data);
                dispatch('setMessageToast', data);
            }
        }

    },
    getters: {
        getMessageList(state){
            return state.messageList;
        },
        getMessageCount(state){
            return state.messageCount;
        },
        getMessageUnreadCount(state){
            return state.messageUnreadCount;
        }
    }
}
export default message